import styled from '@emotion/styled/macro';

import { Root as ButtonRoot } from 'components/buttons/styles';

export const ModalRoot = styled.div(() => ({
  outline: 'none',
}));

export const ModalControls = styled.div((props) => ({
  // @ts-ignore
  [ButtonRoot]: {
    minWidth: 'unset',
    width: 20,
    height: 20,
    padding: 4,
    span: {
      lineHeight: 0.5,
    },
  },
}));

export const PanelContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 20,
  maxWidth: 420,
  padding: '0 12px 12px 12px',
}));

export const FieldSection = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 8,
  width: '100%',
}));

export const Label = styled.span((props) => ({
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
}));

export const Hint = styled.span((props) => ({
  fontSize: 12,
  lineHeight: '16px',
  color: props.theme.colors.inactive,
  fontFamily: props.theme.fonts.primary,
}));

export const Delimeter = styled.div((props) => ({
  borderBottom: `1px solid ${props.theme.colors.container.primary}`,
  width: '100%',
}));

export const Buttons = styled.div(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 16,
}));

export const Warning = styled.div((props) => ({
  fontSize: 13,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.warning.main,
}));

export const RevealRow = styled.div(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  width: '100%',
}));

export const RevealValue = styled.span((props) => ({
  fontFamily: 'monospace',
  fontSize: 13,
  wordBreak: 'break-all',
  color: props.theme.colors.primary,
  flex: 1,
}));
